import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import UltraVioLetMappingForm from "./UltraVioLetMappingForm";
import UltraVioletCredentialsForm from "./UltraVioletCredentialsForm";

const UltraVioLetConfigLising = (props) => {
    const columns = useMemo(
        () => [
            {
                title: "Name",
                dataIndex: "targetName",
                width: 150,
                render: (name) => {
                    try {
                        const names = JSON.parse(name);
                        return columnRenderArrayData(names.join(","));
                    } catch {
                        return columnRenderArrayData(name);
                    }
                },
            },
            {
                title: "Type",
                dataIndex: "type",
                width: 150,
                render: (type) => columnRenderArrayData(type),
            },
        ],
        [],
    );

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={UltraVioLetMappingForm}
            CredentialsForm={UltraVioletCredentialsForm}
            extraColumns={columns}
        />
    );
};

export default UltraVioLetConfigLising;
